export const formatAuthorName = (fullName: string | null | undefined): string => {
  if (!fullName) return 'Unknown';
  const parts = fullName.trim().split(/\s+/);
  if (parts.length <= 1) return parts[0];
  
  const firstName = parts[0];
  const lastName = parts[parts.length - 1];
  const lastInitial = lastName.charAt(0);
  
  return `${firstName} ${lastInitial}.`;
};
